<template>


</template>

<script>

import Storage from '@/helpers/storage'

import Share from '@/modules/share'
import Tracking from '@/modules/tracking'
import UserAgent from '@/modules/userAgent'
import UserFlow from '@/modules/userFlow'

export default {

    name: 'save-the-planet',


    data() {
        return {}
    },

    created() {

        Tracking.saveTracking(this.$route.query)

        UserFlow.setPage(this, 'save-the-planet')

        this.redirect()

    },

    mounted() {


        const partnerCode = this.$route.query.partnerCode

        if(partnerCode) {
            Storage.setItem('partnerCode', partnerCode)
        }

    },

    methods: {

        redirect() {

            if (UserAgent.is.mobile()) {

                if (UserAgent.is.ios()) {

                    Share.downloadIosApp(true)

                } else if (UserAgent.is.android()) {

                    Share.downloadAndroidApp(true)

                }

            }

            this.$router.push({path: '/'})

        }

    }
}
</script>

<style scoped lang="scss">

</style>
